/**
 * Created by Administrator on 2018-06-01.
 */
//获取cookie、
const Cookie = require('js-cookie')


export function getCookie(name) {
  // debugger
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    // console.log("🚀 ~ document.cookie", document.cookie)
    return (unescape(arr[2]));
  }
  else
    return null;
}


//设置cookie,增加到vue实例方便全局调用   
//  增加了path选项，
export function setCookie(c_name, value, expiredays, path, mode) {
  var exdate = new Date();

  if (c_name == 'RNavRecord') {
    exdate.setDate(exdate.getDate() + expiredays); //设置有效期时分秒为0:0:0
    exdate.setHours(0);
    exdate.setMinutes(0);
    exdate.setSeconds(0);
  } else {
    exdate.setDate(exdate.getDate() + expiredays); //设置有效期
  }
  let cookStr = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
  // 本地局域网访问需要把域名修改为本地ip，这样cookie才能存入本地
  // let cookStr = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + "; domain=192.168.1.168";
  // if (path) {
  //   // document.cookie = cookStr + "; path=" + path + ";";
  //   document.cookie = cookStr + "; path=/;";
  // } else {
  //   document.cookie = cookStr
  // }
  document.cookie = cookStr + "; path=/;";
};


//删除cookie
export function delCookie(name) {
  Cookie.remove(name)
  // var exp = new Date();
  // exp.setTime(exp.getTime() - 1);
  // var cval = getCookie(name);
  // if (cval != null)
  //   document.cookie = name + "=" + cval +';domain=.by56.com'+ ";expires=" + exp.toGMTString();
};





